module.exports = __webpack_public_path__ + "static/gallery18-89813c3173727951544ed31c6a5899b6.jpg";